import React from "react";
import point from "./../../../../Images/point.png";

const NailExtensionInLavelleMaintain = () => {
  return (
    <div className="hairSalonInSahakaraWhy">
      <h5>Care and Maintenance Tips for Nail Extensions</h5>
      <p>
        To make the most of your nail extensions near Lavelle Road, follow these
        care and maintenance tips:
      </p>
      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Keep Them Dry{" "}
          </span>
          <p>
            Prolonged exposure to water can weaken your extensions. Wear gloves
            when washing dishes or handling cleaning products.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Moisturize Regularly{" "}
          </span>
          <p>
            Hydrating your cuticles and hands keeps your nails looking fresh and
            prevents them from drying out.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Avoid Using Nails as Tools{" "}
          </span>
          <p>
            Using your nails to open containers or perform similar tasks can
            lead to cracks and breaks. Treat your extensions with care to extend
            their life.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Schedule Regular Fills{" "}
          </span>
          <p>
            Extensions require maintenance every 2-3 weeks. Regular fills help
            keep your nails looking perfect and prevent any potential damage.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Use Gentle Nail Polish Removers{" "}
          </span>
          <p>
            If you want to change your polish, opt for an acetone-free remover,
            as harsh chemicals can damage your extensions.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default NailExtensionInLavelleMaintain;
